export default __webpack_public_path__ + "static/media/producto-06.acc3fbb1.jpg";